import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@flexiflow-ui-kit/icon';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var PaginationContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  ", ";\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var PaginationButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 14px;\n  line-height: 20px;\n  padding: 6px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 3px;\n  background-color: ", ";\n\n  :hover:not(:disabled) {\n    background-color: ", ";\n  }\n\n  :disabled {\n    cursor: not-allowed;\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.predefinedCss.buttonReset;
}, function (p) {
  return p.$isSelected ? p.theme.palette.gray['200'] : p.theme.palette.white;
}, function (p) {
  return p.$isSelected ? p.theme.palette.gray['200'] : p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.gray['500'];
});

function Pagination(_ref) {
  var pageFromProps = _ref.page,
      pagesFromProps = _ref.pages,
      _ref$intervalWidth = _ref.intervalWidth,
      intervalWidth = _ref$intervalWidth === void 0 ? 4 : _ref$intervalWidth,
      onChange = _ref.onChange;
  var pages = pagesFromProps < 1 ? 1 : pagesFromProps;
  var page = pageFromProps;

  if (page < 1) {
    page = 1;
  }

  if (page > pages) {
    page = pages;
  }

  var showLeftDots = page - (intervalWidth + 1) > 1;
  var showRightDots = page + intervalWidth + 1 < pages;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(PaginationContainer, null, /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: false,
    onClick: function onClick() {
      return onChange(page - 1);
    },
    disabled: page === 1
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    width: 7,
    height: 11
  })), /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: page === 1,
    onClick: function onClick() {
      return page !== 1 && onChange(1);
    }
  }, "1"), showLeftDots && /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: false,
    onClick: function onClick() {
      return onChange(page - (intervalWidth + 1));
    }
  }, "..."), numbersArrayFromInterval(page, pages, [page - intervalWidth, page - 1]).map(function (pageNumber) {
    return /*#__PURE__*/React.createElement(PaginationButton, {
      key: pageNumber,
      $isSelected: false,
      onClick: function onClick() {
        return onChange(pageNumber);
      }
    }, pageNumber);
  }), page !== 1 && page !== pages && /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: true
  }, page), numbersArrayFromInterval(page, pages, [page + 1, page + intervalWidth]).map(function (pageNumber) {
    return /*#__PURE__*/React.createElement(PaginationButton, {
      key: pageNumber,
      $isSelected: false,
      onClick: function onClick() {
        return onChange(pageNumber);
      }
    }, pageNumber);
  }), showRightDots && /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: false,
    onClick: function onClick() {
      return onChange(page + (intervalWidth + 1));
    }
  }, "..."), pages > 1 && /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: page === pages,
    onClick: function onClick() {
      return onChange(pages);
    }
  }, pages), /*#__PURE__*/React.createElement(PaginationButton, {
    $isSelected: false,
    onClick: function onClick() {
      return page !== pages && onChange(page + 1);
    },
    disabled: page === pages
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    width: 7,
    height: 11
  }))));
}

function numbersArrayFromInterval(page, pages, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      intervalStart = _ref3[0],
      intervalEnd = _ref3[1];

  var start = intervalStart;
  var end = intervalEnd;

  if (start < 2) {
    start = 2;
  }

  if (end >= pages) {
    end = pages - 1;
  }

  if (start > end) {
    return [];
  }

  if (start === end) {
    return [start];
  }

  var numbers = [];

  for (var i = start; i <= end; i++) {
    numbers.push(i);
  }

  return numbers;
}

export { Pagination };
